import React from 'react';
import { Link } from 'react-router-dom';
import '../styling/ProductsSubpages.css';
import bat1 from '../styling/images/battery/drybattery/category1a.png';
import bat2 from '../styling/images/battery/drybattery/category1b.png';
import bat3 from '../styling/images/battery/drybattery/category1c.png';
import bat4 from '../styling/images/battery/tubularbattery/category2a.png';

const Battery = () => {
  const categories = [
    { 
      id: 1,
      name: 'DRY BATTERY',
      images: [
        { id: 1, src: bat1, caption1: 'Battery VRLA', caption2: '12V ~ 5AH to 100AH' },
        { id: 2, src: bat2, caption1: 'Lion or Lipo', caption2: '12V, 24V, 48V, 96V, 384V ~ 5AH to 300AH' },
        { id: 3, src: bat3, caption1: 'Cell VRLA', caption2: '2V ~ 300AH to 1000AH' }
      ]
    },{
      id: 2,
      name: 'TUBULAR BATTERY', 
      images: [
        { id: 4, src: bat4, caption1: 'Tubular Battery' }
      ]
    }
  ];

  const scrollToHeading = (headingId) => {
    const element = document.getElementById(headingId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className='container'>
      <nav className="side-nav">
        <ul>
          {categories.map(category => (
            <li key={category.id}>
              <button onClick={() => scrollToHeading(`heading-${category.id}`)}>{category.name}</button>
              <ul>
                {category.images.map(image => (
                  <li key={image.id}>
                    <Link to={`/product_items/Battery_cat/BatterySubpages/${image.id}`}>
                      {image.caption1}  {image.caption2}
                    </Link>
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </nav>
      <div className="content">
        <h1>BATTERY</h1>
        {categories.map(category => (
          <div key={category.id} id={`heading-${category.id}`}>
            <h2>{category.name}</h2>
            <div className='row'>
              {category.images.map(image => (
                <div key={image.id} className='category-products'>
                  <Link to={`/product_items/Battery_cat/BatterySubpages/${image.id}`}  state={{ productCategory: category.name, productCap1: image.caption1, productCap2: image.caption2}}>
                    <img src={image.src} alt={`Image ${image.id}`} className='category-images'/>
                  </Link>
                  <p>{image.caption1}<br/>{image.caption2}</p>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Battery;
